// import images here and use in combination
import terra120 from '../../../images/ColoriFormatiPage/combinations/REFIN_affrescati_LP_CONF_TERRA-120X120.jpg'
import terra60 from '../../../images/ColoriFormatiPage/combinations/REFIN_affrescati_LP_CONF_TERRA-60X120.jpg'
import terra80 from '../../../images/ColoriFormatiPage/combinations/REFIN_affrescati_LP_CONF_TERRA-80X80.jpg'
import terra40 from '../../../images/ColoriFormatiPage/combinations/REFIN_affrescati_LP_CONF_TERRA-40X80.jpg'
import ocra120 from '../../../images/ColoriFormatiPage/combinations/REFIN_affrescati_LP_CONF_OCRA-120X120.jpg'
import ocra60 from '../../../images/ColoriFormatiPage/combinations/REFIN_affrescati_LP_CONF_OCRA-60X120.jpg'
import ocra80 from '../../../images/ColoriFormatiPage/combinations/REFIN_affrescati_LP_CONF_OCRA-80X80.jpg'
import ocra40 from '../../../images/ColoriFormatiPage/combinations/REFIN_affrescati_LP_CONF_OCRA-40X80.jpg'
import calce120 from '../../../images/ColoriFormatiPage/combinations/REFIN_affrescati_LP_CONF_CALCE-120X120.jpg'
import calce60 from '../../../images/ColoriFormatiPage/combinations/REFIN_affrescati_LP_CONF_CALCE-60X120.jpg'
import calce80 from '../../../images/ColoriFormatiPage/combinations/REFIN_affrescati_LP_CONF_CALCE-80x80.jpg'
import calce40 from '../../../images/ColoriFormatiPage/combinations/REFIN_affrescati_LP_CONF_CALCE-40X80.jpg'
import ombra120 from '../../../images/ColoriFormatiPage/combinations/REFIN_affrescati_LP_CONF_OMBRA-120X120.jpg'
import ombra60 from '../../../images/ColoriFormatiPage/combinations/REFIN_affrescati_LP_CONF_OMBRA-60X120.jpg'
import ombra80 from '../../../images/ColoriFormatiPage/combinations/REFIN_affrescati_LP_CONF_OMBRA-80x80.jpg'
import ombra40 from '../../../images/ColoriFormatiPage/combinations/REFIN_affrescati_LP_CONF_OMBRA-40X80.jpg'
import lapis120 from '../../../images/ColoriFormatiPage/combinations/REFIN_affrescati_LP_CONF_LAPIS-120X120.jpg'
import lapis60 from '../../../images/ColoriFormatiPage/combinations/REFIN_affrescati_LP_CONF_LAPIS-60X120.jpg'
import lapis80 from '../../../images/ColoriFormatiPage/combinations/REFIN_affrescati_LP_CONF_LAPIS-80X80.jpg'
import lapis40 from '../../../images/ColoriFormatiPage/combinations/REFIN_affrescati_LP_CONF_LAPIS-40X80.jpg'

const combinations = {
    1: {
        1: {
            image: terra120
        },
        2: {
            image: terra60
        },
        3: {
            image: terra80
        },
        4: {
            image: terra40
        }
    },
    2: {
        1: {
            image: ocra120
        },
        2: {
            image: ocra60
        },
        3: {
            image: ocra80
        },
        4: {
            image: ocra40
        }
    },
    3: {
        1: {
            image: calce120
        },
        2: {
            image: calce60
        },
        3: {
            image: calce80
        },
        4: {
            image: calce40
        }
    },
    4: {
        1: {
            image: ombra120
        },
        2: {
            image: ombra60
        },
        3: {
            image: ombra80
        },
        4: {
            image: ombra40
        }
    },
    5: {
        1: {
            image: lapis120
        },
        2: {
            image: lapis60
        },
        3: {
            image: lapis80
        },
        4: {
            image: lapis40
        }
    },
}

export default combinations